<div
  class="bg-components-background-neutral-lightest m-xs p-xs gap-xs shadow-bottom flex w-[424px] flex-wrap justify-start rounded-sm"
>
  @for (finParcours of finsParcours(); track finParcours.id) {
    <div
      class="border-stroke-neutral-medium text-components-content-neutral-primary hover:border-stroke-primary-main hover:bg-components-background-primary-lightest p-xs flex h-[64px] w-[200px] cursor-pointer flex-col items-center justify-center rounded-sm border"
      (click)="clickHandler(finParcours)"
    >
      <span class="paragraph-medium-semibold">{{ finParcours.nom }}</span>
    </div>
  }
</div>
